module.exports = __webpack_public_path__ + "static/media/githubLogo.734888c8.png";